import * as Highcharts from 'highcharts';
import * as jQuery from 'jquery';
import * as moment from 'moment';

import { Component, Input, OnInit } from '@angular/core';

import { CreativePerformanceGraphComponent } from '../../creative-performace-v1/creative-performance-graph/creative-performance-graph.component';

@Component({
	selector: 'app-creative-performance-graph-v7',
	styleUrls: ['./creative-performance-graph-v7.component.css'],
	templateUrl: './creative-performance-graph-v7.component.html'
})
export class CreativePerformanceGraphV7Component extends CreativePerformanceGraphComponent implements OnInit {
	@Input() legendData: any;
	public lineWidth = 0;
	public secondaryYaxisLabel = '';
	public primaryYaxisLabel = '';

	constructor() {
		super();
	}

	ngOnInit(): void {
		super.ngOnInit();
	}

	updateLegends(legendItem: any, index: number): void {
		if (!this.legendData[index]['active'] || !this.legendData[index]['selected']) {
			for (let i = 0; i < this.legendData.length; i++) {
				this.legendData[i]['active'] = false;
				this.legendData[i]['selected'] = false;
				this.graphData.series[i]['visible'] = false;
				this.chartObj.series[i].hide();

				if (i === index) {
					this.legendData[i]['active'] = true;
					this.legendData[i]['selected'] = true;
					this.graphData.series[i]['visible'] = true;
					this.chartObj.yAxis[this.graphData.series[i]['yAxis']].setTitle({
						text: this.legendData[i].displayName
					});
					this.chartObj.series[i].show();
				}
			}
			const activeLegends = this.legendData.filter((legend) => {
				if (legend.active) {
					return legend;
				}
			});
			this.lineWidth = activeLegends.length ? 0 : 1;
			this.legendSelected.emit(legendItem);
		}
	}

	getColors(index: number): string {
		return this.chartObj.series[index].color;
	}

	drawGraph(): void {
		this.secondaryYaxisLabel = this.legendData[0].displayName;
		this.primaryYaxisLabel = this.legendData[this.legendData.length - 1].displayName;
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		this.selectedMetric = this.getSelectedLegend();
		Highcharts.setOptions({
			lang: {
				thousandsSep: ','
			}
		});
		this.chartObj = Highcharts.chart(
			this.graphElement.nativeElement,
			{
				chart: {
					events: {
						click: (event) => {
							this.clickEvent(event);
						}
					},
					ignoreHiddenSeries: true,
					margin: [40, 100, 60, 100],
					type: self.chartType || 'area',
					zoomType: 'xy'
				},
				credits: {
					enabled: false
				},
				legend: {
					enabled: false
				},
				plotOptions: {
					area: {
						marker: {
							enabled: false
						}
					},
					series: {
						marker: {
							enabled: false,
							states: {
								hover: {
									enabled: false
								}
							}
						},
						point: {
							events: {
								mouseOut: (event) => {
									this.mouseOutEvent(event);
								},
								mouseOver: (event) => {
									this.mouseOverEvent(event);
								}
							}
						}
					}
				},
				series: this.graphData.series,
				subtitle: {
					text: null
				},
				title: {
					text: null
				},
				tooltip: {
					backgroundColor: '#ffffff',
					borderRadius: 5,
					borderWidth: 0,
					formatter(): string {
						return `<div class="legendClass">
								<div class="width100">${this.series.name}</div>
								<div class="width100 yAxis weight600">${this.point.y.toLocaleString()}</div>
								<div class="width100 date">${moment(this.x).format('MM/DD/YY')}</div>
						</div>`;
					},
					useHTML: true
				},
				xAxis: {
					categories: this.graphData.categories,
					gridLineColor: 'transparent',
					labels: {
						formatter(): string {
							return moment(this.value).format('MMM YYYY');
						},
						autoRotation: [-10, -20, -30, -40, -50, -60, -70, -80, -90],
						style: { color: '#213038' }
					},
					lineColor: '#e6e6e6',
					lineWidth: this.lineWidth,
					minorGridLineWidth: 0,
					minorTickLength: 0,
					offset: 5,
					tickInterval: 1,
					tickLength: 0,
					type: 'datetime'
				},
				yAxis: [
					{
						labels: {
							align: 'left',
							style: { color: '#213038' },
							useHTML: true,
							formatter(): string {
								if (this.value >= 1000) {
									return `<span class='xlabel'>${ Number(this.value) / 1000}k<span>`;
								} else {
									if ( Number(this.value) % 1 !== 0) {
										return `<span class='xlabel'>${parseFloat(String(this.value)).toFixed(2)}<span>`;
									}
									return `<span class='xlabel'>${this.value}<span>`;
								}
							}
						},
						opposite: true,
						showEmpty: false,
						title: {
							align: 'high',
							offset: 0,
							rotation: 0,
							style: { color: '#213038' },
							text: this.primaryYaxisLabel,
							x: 14,
							y: -20
						}
					},
					{
						labels: {
							align: 'right',
							formatter(): string {
								if (this.value >= 1000) {
									return `<span class='xlabel'>${ Number(this.value) / 1000}k<span>`;
								} else {
									return `<span class='xlabel'>${this.value}<span>`;
								}
							},
							style: { color: '#213038' },
							useHTML: true
						},
						showEmpty: false,
						title: {
							align: 'high',
							offset: 0,
							rotation: 0,
							style: { color: '#213038' },
							text: this.secondaryYaxisLabel,
							x: -16,
							y: -20
						}
					}
				]
			},
			(chart: any) => {
				// on complete
				function noop(): void {}

				if (this.dataLength > this.maxPoints) {
					this.leftExtreme = this.dataLength - this.maxPoints > 0 ? this.dataLength - this.maxPoints : 0;
					this.rightExtreme = this.dataLength;

					chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
					if (!self.svgHeight) {
						chart.renderer
							.image('../../../../../../assets/creative-assets/arrow-left.png', 0, 0, 6, 9)
							.addClass('left_' + this.name)
							.addClass('cursorPointer')
							.attr('x', '8%')
							.attr('y', '45%')
							.add();
						chart.renderer
							.image('../../../../../../assets/creative-assets/arrow-right.svg', 0, 0, 6, 9)
							.addClass('right_' + this.name)
							.addClass('cursorPointer')
							.attr('x', '99%')
							.attr('y', '45%')
							.add();
						jQuery('.left_' + this.name).click(() => {
							if (this.leftExtreme > 0) {
								this.rightExtreme = this.leftExtreme - 1;
								this.leftExtreme = this.leftExtreme - this.maxPoints > 0 ? this.leftExtreme - this.maxPoints : 0;
								chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							}
						});
						jQuery('.right_' + this.name).click(() => {
							if (this.rightExtreme < this.dataLength) {
								this.leftExtreme = this.rightExtreme + 1;
								this.rightExtreme =
									this.leftExtreme + this.maxPoints > this.dataLength
										? this.dataLength
										: this.leftExtreme + this.maxPoints;
								chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							}
						});
					}
				}
			}
		);
	}
}
